import type {
    MembershipBillingFrequency,
    SubscriptionProductId,
} from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

export interface CreateTestUserResponseDto {
    success: boolean;
    user: {
        id: string;
        email: string;
        firstName: string;
        lastName: string;
        stytchId: string;
    };
    membership: {
        id: string;
    };
    moneyMap: {
        id: string;
        status: string;
    };
    credentials: {
        email: string;
        password: string;
    };
}

export interface CreateTestUserBody {
    email: string;
    firstName?: string;
    lastName?: string;
    password?: string;
    /** Non-prod only — omit for the default trial_premium -> standard schedule. */
    subscriptionProductId?: SubscriptionProductId;
    /** Only used alongside subscriptionProductId; omit for that product's default frequency. */
    billingFrequency?: MembershipBillingFrequency;
    /** When true, seeds a placeholder draft money map (goals/bills/debts/savings) instead of the bare default. */
    withPlaceholderMoneyMap?: boolean;
}

const useCreateTestUser = requestBuilder.mutation<
    CreateTestUserResponseDto,
    CreateTestUserBody
>({
    endpoint: '/api/dev/create-test-user',
    method: 'POST',
});

export default useCreateTestUser;
